const config = {
  baseApiURL: 'https://floating-waters-77952.herokuapp.com',
  bidsWebSocketURL: 'wss://floating-waters-77952.herokuapp.com',
  userInfo: 'userInfo',
  keyForSaveToken: 'Authorization',
  tokenExpirationTime: 7,
  adminRole: 'admin',
};

export default config;


// WEBPACK FOOTER //
// ./src/config.js